
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/book-trip",
      function () {
        return require("private-next-pages/[region]/[resort]/book-trip.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/book-trip"])
      });
    }
  